import { privacyOptions } from "../../labels";
import { type SubtypeSectionProps, subtypeControls } from "./support";
import { fieldGrid } from "../../components/styles";

export const experienceFieldLabels = {
  durationMinutes: "Duration (minutes)",
  privacy: "Privacy",
  groupMin: "Smallest group",
  groupMax: "Largest group",
  minimumAge: "Minimum age",
  eligibilityNotes: "Eligibility notes",
  includes: "Includes",
  excludes: "Excludes",
  meetingPointText: "Meeting point",
} as const;

export function ExperienceSection(props: SubtypeSectionProps) {
  const c = subtypeControls(props);
  return (
    <div className={fieldGrid}>
      {c.whole("durationMinutes", experienceFieldLabels.durationMinutes, {
        hint: "Up to 10,080 (one week).",
      })}
      {c.select("privacy", experienceFieldLabels.privacy, privacyOptions, "Not set")}
      {c.whole("groupMin", experienceFieldLabels.groupMin)}
      {c.whole("groupMax", experienceFieldLabels.groupMax)}
      {c.whole("minimumAge", experienceFieldLabels.minimumAge)}
      {c.text("meetingPointText", experienceFieldLabels.meetingPointText, { maxLength: 300 })}
      {c.area("eligibilityNotes", experienceFieldLabels.eligibilityNotes, {
        rows: 3,
        maxLength: 2000,
      })}
      {c.area("includes", experienceFieldLabels.includes, { rows: 3, maxLength: 2000 })}
      {c.area("excludes", experienceFieldLabels.excludes, { rows: 3, maxLength: 2000 })}
    </div>
  );
}
